export async function submitGameResult({ userId, points, time, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/submitGameResult`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({ userId, points, time }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to submit game result");
  }
  return data;
}
